import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getFornecedoresRequest: null,
  getFornecedoresSuccess: ['fornecedores'],
  getFornecedoresFailure: ['error'],
  addFornecedorRequest: ['fornecedor', 'closeModal'],
  addFornecedorSuccess: ['fornecedor'],
  addFornecedorFailure: ['error'],
  updateFornecedorRequest: ['fornecedor', 'closeModal'],
  updateFornecedorSuccess: ['fornecedor'],
  updateFornecedorFailure: ['error'],
  removeFornecedorRequest: ['id'],
  removeFornecedorSuccess: ['id'],
  removeFornecedorFailure: ['error'],
  openModal: null,
  closeModal: null,
  setFornecedorActive: ['fornecedor'],
});

export const FornecedoresTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  fornecedores: [],
  fornecedorActive: null,
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getFornecedoresRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getFornecedoresSuccess = (state, { fornecedores }) =>
  state.merge({
    fornecedores,
    isLoading: false,
    error: null,
  });

const getFornecedoresFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addFornecedorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addFornecedorSuccess = (state, { fornecedor }) =>
  state.merge({
    fornecedores: [...state.fornecedores, fornecedor],
    isLoading: false,
    error: null,
  });

const addFornecedorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateFornecedorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateFornecedorSuccess = (state, { fornecedor }) =>
  state.merge({
    fornecedores: state.fornecedores.map((item) =>
      item.id === fornecedor.id ? fornecedor : item
    ),
    isLoading: false,
    error: null,
  });

const updateFornecedorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeFornecedorRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeFornecedorSuccess = (state, { id }) =>
  state.merge({
    fornecedores: state.fornecedores.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeFornecedorFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModal = (state) =>
  state.merge({
    openModal: true,
  });

const closeModal = (state) =>
  state.merge({
    openModal: false,
    fornecedorActive: null,
  });

const setFornecedorActive = (state, { fornecedor }) =>
  state.merge({
    fornecedorActive: fornecedor,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FORNECEDORES_REQUEST]: getFornecedoresRequest,
  [Types.GET_FORNECEDORES_SUCCESS]: getFornecedoresSuccess,
  [Types.GET_FORNECEDORES_FAILURE]: getFornecedoresFailure,
  [Types.ADD_FORNECEDOR_REQUEST]: addFornecedorRequest,
  [Types.ADD_FORNECEDOR_SUCCESS]: addFornecedorSuccess,
  [Types.ADD_FORNECEDOR_FAILURE]: addFornecedorFailure,
  [Types.UPDATE_FORNECEDOR_REQUEST]: updateFornecedorRequest,
  [Types.UPDATE_FORNECEDOR_SUCCESS]: updateFornecedorSuccess,
  [Types.UPDATE_FORNECEDOR_FAILURE]: updateFornecedorFailure,
  [Types.REMOVE_FORNECEDOR_REQUEST]: removeFornecedorRequest,
  [Types.REMOVE_FORNECEDOR_SUCCESS]: removeFornecedorSuccess,
  [Types.REMOVE_FORNECEDOR_FAILURE]: removeFornecedorFailure,
  [Types.OPEN_MODAL]: openModal,
  [Types.CLOSE_MODAL]: closeModal,
  [Types.SET_FORNECEDOR_ACTIVE]: setFornecedorActive,
});

